var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isJettonWallet)?_c('jetton-wallet',_vm._b({attrs:{"address":_vm.address}},'jetton-wallet',_vm.jettonProps,false)):_c('jetton-info',_vm._b({attrs:{"address":_vm.address,"imageTA":_vm.imageTA}},'jetton-info',_vm.jettonProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }